import { render, staticRenderFns } from "./RegistrationVerigram.vue?vue&type=template&id=750083f4&scoped=true"
import script from "./RegistrationVerigram.vue?vue&type=script&lang=ts"
export * from "./RegistrationVerigram.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationVerigram.vue?vue&type=style&index=0&id=750083f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750083f4",
  null
  
)

export default component.exports